module.exports = __webpack_public_path__ + "img/file-minus-fill.aaf0b998.svg";